var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../../../atoms/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '../../../atoms/vertical-layout/vertical-layout.js';
import '../../../atoms/horizontal-layout/horizontal-layout.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { SgdfElement } from '../../../internal/sgdf-element.js';
import styles from './result-card.styles.js';
let SgdfResultCard = class SgdfResultCard extends SgdfElement {
    async onClick() {
        this.emit('sgdf-select-entity', {
            detail: this.result,
        });
    }
    render() {
        return html `
            <div class="card" @click=${this.onClick}>
                <sgdf-horizontal-layout
                    style="align-items: center;"
                    theme="spacing"
                >
                    ${this.result.type === 'participant'
            ? html `<sl-avatar
                                  shape="rounded"
                                  image=${ifDefined(this.result.picture)}
                              ></sl-avatar>`
            : html ` <sl-avatar
                                  shape="rounded"
                                  initials="EQ"
                              ></sl-avatar>`}
                    <sgdf-vertical-layout>
                        <strong class="name">${this.result.name}</strong>
                        <p class="description">${this.result.description}</p>
                    </sgdf-vertical-layout>
                </sgdf-horizontal-layout>
            </div>
        `;
    }
};
SgdfResultCard.styles = styles;
__decorate([
    property({ type: Object, reflect: true })
], SgdfResultCard.prototype, "result", void 0);
SgdfResultCard = __decorate([
    customElement('sgdf-result-card')
], SgdfResultCard);
export default SgdfResultCard;
//# sourceMappingURL=result-card.js.map